import { Namespace, TFunction } from 'i18next';

export const getConsentOptions = (
	t: TFunction<Namespace>
): { id: boolean; label: string }[] => [
	{ id: true, label: t('commonButton:yes') },
	{ id: false, label: t('commonButton:no') },
];
